/* global gapi */
import './assets/css/main.scss'

import logoutProcess from '@/lib/utils/session'
import router from '@/router'
import store from '@/store'
import Clipboard from 'v-clipboard'
import Vue from 'vue'
import {
	MdBadge,
	MdButton,
	MdCard,
	MdDialog,
	MdDialogAlert,
	MdIcon,
	MdProgress
} from 'vue-material/dist/components'
import VueRouter from 'vue-router'

import { DateUtilPlugin } from './lib/plugins/date'
import { ValidatorPlugin } from './lib/plugins/validatorPlugin'
import { installQuasar } from './lib/utils/quasar'
import { initRolePermissionList } from './permission/rolePermission'

installQuasar()

Vue.use(MdBadge)
Vue.use(MdButton)
Vue.use(MdDialog)
Vue.use(MdProgress)
Vue.use(MdDialogAlert)
Vue.use(MdIcon)
Vue.use(MdCard)
Vue.use(Clipboard)
Vue.use(ValidatorPlugin)
Vue.use(DateUtilPlugin)
Vue.use(VueRouter)
Vue.config.productionTip = false

new Vue({
	el: '#app',
	router,
	store,
	components: {
		ErrorBoundary: () => import('./components/ErrorBoundary.vue')
	},
	data() {
		const prodEnvs = ['stage', 'beta', 'prod']
		return {
			email: localStorage.getItem('email'),
			env: prodEnvs.includes(process.env.VUE_APP_ENV)
				? 'prod'
				: 'nonProd',
			isInitialised: false
		}
	},
	async mounted() {
		const { VUE_APP_ENV, VUE_APP_GOOGLE_CLIENT_ID, VUE_APP_VERSION } =
			process.env
		if (gapi.auth2) {
			return
		}
		gapi.load('auth2', () => {
			gapi.auth2.init({
				client_id: VUE_APP_GOOGLE_CLIENT_ID,
				fetch_basic_profile: true,
				scope: 'profile'
			})
		})
		if (VUE_APP_ENV !== 'prod') {
			document.title = `${VUE_APP_ENV.toUpperCase()} Back Office ${VUE_APP_VERSION}`
		}

		if (localStorage.getItem('token')) {
			await initRolePermissionList()
		}
		this.isInitialised = true
	},
	methods: {
		async logout() {
			logoutProcess()
		}
	}
})
